"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatus_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var JobStatus_Factory = /** @class */ (function () {
    function JobStatus_Factory() {
    }
    JobStatus_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RowVersion: model.RowVersion,
            Status: model.Status,
        };
        return result;
    };
    JobStatus_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RowVersion: model.RowVersion,
            Status: model.Status,
        };
        return result;
    };
    return JobStatus_Factory;
}());
exports.JobStatus_Factory = JobStatus_Factory;
